export default __webpack_public_path__ + "f6f926370a4260c50101e0ccd7a62e2a.twig";